import React from 'react';
import Footer from './Footer';
import tours from '../utils/tours.json';
import { useParams } from 'react-router-dom';
import { MegaMenu } from './MegaMenu';
import FeaturesGrid from './features-grid';

const Tours = () => {
  const params = useParams();
  const tour = tours.find((tour) => tour.tourId === params.id);

  if (!tour) {
    return (
      <div>
        <MegaMenu/>
        <div className="text-center py-20">
          <h1 className="text-2xl font-bold">Tour not found</h1>
          <p className="text-gray-600">The tour you're looking for doesn't exist.</p>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div>
       <MegaMenu/>
      {/* Hero Section */}
      <div className="relative h-[100vh]">
        {/* Background Image */}
        <div className="absolute inset-0 h-full">
          <img
            src={tour.heroImage}
            alt="Background"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Overlay Content */}
        <div className="absolute inset-0 z-10 flex flex-col items-center justify-center text-center px-6 md:px-8 lg:px-16 bg-black bg-opacity-60">
          <h1 className="text-white text-2xl sm:text-4xl md:text-5xl lg:text-7xl font-bold leading-tight lg:leading-snug noto">
            {tour.title}
          </h1>
          <p className=' text-white '>{tour.description}</p>



        </div>
      </div>

      {/* Itinerary Section */}
      <div className="container mx-auto px-4 py-10 ">
        <h2 className="text-3xl lg:text-4xl notoh font-bold text-gray-800 mb-6 italic">Tour Itinerary</h2>

        {/* Flex Layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:gap-10">
          {tour.days.map((day, dayIndex) => (
            <div
              key={dayIndex}
              className="h-full"
            >
              <div className="bg-white shadow-md rounded-lg overflow-hidden h-full">
                {/* Day Image */}
                <div
                  className="w-full h-64 bg-cover bg-center"
                  style={{ backgroundImage: `url(${day.dayImage})` }}
                ></div>
                {/* Day Details */}
                <div className="p-6 ">
                  {/* Day Title */}
                  <h3 className="text-2xl font-semibold text-gray-700 mb-4">{day.dayTitle}</h3>
                  {/* Schedule */}
                  {day.schedule.map((event, eventIndex) => (
                    <div
                      key={eventIndex}
                      className=" py-4"
                    >
                      {/* <p className="text-gray-600 font-medium">{event.timeRange}</p> */}
                      <p className="text-gray-800">{event.activity}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
          <FeaturesGrid/>

      <Footer />
    </div>
  );
};

export default Tours;
